import React from 'react';
import DataResource from './../../../common/v4/DataResource';
import Panel from './../../../common/layout/Panel';
import Tabs from './../../../common/Tabs';

const tabs = [
    {
        link: '/clients/companies',
        name: 'Companies'
    },
    {
        link: '/clients/branches',
        name: 'Branches'
    },
    {
        link: '/clients/teams',
        name: 'Teams'
    }
] 

const BranchesIndex = (props) => {
    const data = {
        url: '/admin/clients/branches',
        data: {
            data: [],
            metadata: []
        },
        onclick: 'link',
        link: '/clients/branches/{id}',
        userfilter: [
            {
                source: 'name',
                label: 'Name',
                type: 'text',
                default: ''
            },
            {
                source: 'company_id',
                label: 'Company',
                type: 'select',
                default: ''
            }
        ],
        metadata: [
            {
                label: 'id',
                source: 'id',
                type: 'primary',
                editable: false,
                visible: false
            },
            {
                label: 'Name',
                source: 'name',
                type: 'text',
                editable: true,
                default: '',
                placeholder: 'Branch Name'
            },
            {
                label: 'Company',
                source: 'company_id',
                type: 'select',
            },
            {
                label: 'City',
                source: 'city',
                type: 'text',
            },
            {
                label: 'Country',
                source: 'country',
                type: 'text',
                editable: true,
                default: '',
                placeholder: 'Country'
            },
            {
                label: 'Status',
                source: 'status',
                type: 'boolean',
                editable: true,
                default: true
            },
            {
                label: 'Created',
                source: 'created_at',
                type: 'datetime',
                editable: false,
                visible: true
            }
        ]
    };
    return (
        <Panel title="Branches">
            <div>
                <Tabs tabs={tabs} />
                <DataResource
                    data={data}
                    addButtonText="Create Branch"
                    addButtonLink="/clients/branches/create"
                    {...props}
                />
            </div>
        </Panel>
    );
};

export default BranchesIndex; 